export const translations = {
  tr: {
    tagline: "Kişisel yapay zeka asistanı",
    systemOnline: "SİSTEM ÇEVRİMİÇİ",
    listening: "DİNLİYOR",
    thinking: "DÜŞÜNÜYOR",
    speaking: "KONUŞUYOR",
    idle: "BEKLEMEDE",
    inputPlaceholder: "Sertex'e bir şey söyleyin...",
    send: "Gönder",
    voice: "Ses",
    stop: "Durdur",
    newChat: "Yeni Sohbet",
    history: "Geçmiş",
    notes: "Notlar",
    reminders: "Hatırlatmalar",
    addNote: "Not ekle...",
    addReminder: "Hatırlatma başlığı",
    add: "Ekle",
    delete: "Sil",
    empty: "Henüz kayıt yok.",
    welcome: "Hoş geldiniz efendim. Nasıl yardımcı olabilirim?",
    weatherLabel: "HAVA",
    micUnsupported: "Tarayıcınız ses tanımayı desteklemiyor.",
    micError: "Mikrofon hatası",
    ttsError: "Ses üretilemedi",
    langLabel: "DİL",
    close: "Kapat",
    open: "Aç",
    voiceOn: "Ses Açık",
    voiceOff: "Ses Kapalı",
  },
  en: {
    tagline: "Personal AI assistant",
    systemOnline: "SYSTEM ONLINE",
    listening: "LISTENING",
    thinking: "THINKING",
    speaking: "SPEAKING",
    idle: "STANDBY",
    inputPlaceholder: "Say something to Sertex...",
    send: "Send",
    voice: "Voice",
    stop: "Stop",
    newChat: "New Chat",
    history: "History",
    notes: "Notes",
    reminders: "Reminders",
    addNote: "Add note...",
    addReminder: "Reminder title",
    add: "Add",
    delete: "Delete",
    empty: "No entries yet.",
    welcome: "Welcome, sir. How may I assist you?",
    weatherLabel: "WEATHER",
    micUnsupported: "Your browser does not support speech recognition.",
    micError: "Microphone error",
    ttsError: "Audio generation failed",
    langLabel: "LANG",
    close: "Close",
    open: "Open",
    voiceOn: "Voice On",
    voiceOff: "Voice Off",
  },
};

export const t = (lang, key) => translations[lang]?.[key] ?? key;
